module.exports = __webpack_public_path__ + "img/zhiHuiWenLvText.a830724b.png";